export const SIGN_IN = 'signIn'
export const SIGN_OUT = 'signOut'
export const SET_USER_DATA = 'setUserData'
export const SET_RELEASE_NOTES = 'setReleaseNotes'
export const SET_ADV_MSGS = 'setAdvisoryMessages'

export const SET_CLEARING_SYSTEMS = 'setClearingSystems'

export const SET_FILTERS_DATA = 'setFiltersData'
export const SET_VIEW_REPORT_AS = 'setViewReportAs'

export const UPDATE_CURRENT_CLAIM = 'updateCurrentClaim'
export const RESET_CURRENT_CLAIM = 'resetCurrentClaim'

export const UPDATE_CURRENT_VOUCHER = 'updateCurrentVoucher'
export const RESET_CURRENT_VOUCHER = 'resetCurrentVoucher'

export const UPDATE_CURRENT_REPORT = 'updateCurrentReport'
export const UPDATE_CURRENT_REPORT_FILTERS = 'updateCurrentReportFilters'
export const UPDATE_PARTIAL_REPORT_MESSAGE = 'updatePartialReportMessage'
export const UPDATE_OFFLINE_TIMEOUT_MESSAGE = 'updateOfflineTimeoutMessage'
export const UPDATE_WCF_REQUEST_ID = 'updateWcfRequestId'
export const RESET_CURRENT_REPORT = 'resetCurrentReport'
